import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { CallNumberModel } from '../models/callNumberModel';
import { LUSource } from '../models/luSource';
import { onlyUniqueByKey } from 'starbase-launcher';
import { StarbaseNotificationService, StarbaseNotificationSentiment } from 'starbase-notification';
import { BreakpointService, BreakpointState } from '../breakpoint.service';
import { timeout } from 'rxjs';

@Component({
  selector: 'app-source-call-no-filter',
  templateUrl: './source-call-no-filter.component.html',
  styleUrls: ['./source-call-no-filter.component.css']
})
export class SourceCallNoFilterComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() sourceData: LUSource[] = [];
  @Input() callNumberData: CallNumberModel[] = [];
  @Input() activeFilter: CallNumberModel = new CallNumberModel();

  @Output() changeSourceSelection = new EventEmitter<LUSource>();
  @Output() userSelectionReady = new EventEmitter<CallNumberModel[]>();
  @Output() levelOfSpecificity = new EventEmitter<number>();
  @Output() setCallNumberSelection = new EventEmitter<{ callNumber: string; level: number }>();

  @ViewChild('luSourceDropdown', { static: true }) firstControl: ElementRef;

  public luSourceSelection: LUSource = null;
  public callNumberSourceSelectionId: number;
  public callNumberL1Selection = null;
  public callNumberL2Selection = null;
  public callNumberL3Selection = null;
  public callNumberL4Selection = null;
  public callNumberL2Data: CallNumberModel[] = [];
  public callNumberL3Data: CallNumberModel[] = [];
  public callNumberL4Data: CallNumberModel[] = [];
  callNumberL1DisplayData: CallNumberModel[] = [];
  chosenSourceCallNumberDescription = '';
  working = false;
  restoreData = false;
  restoreLevel = 0;

  private _subscription;
  isHandset: boolean = false;

  constructor(private breakpointService: BreakpointService,
    private notiSvc: StarbaseNotificationService,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {

    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    )
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.callNumberData.unshift(new CallNumberModel().deserialize({ uid: 0, callNumberL1: '', callNumberL2: '', lU_SourceUID: 0 }));
    this.callNumberL1DisplayData = onlyUniqueByKey(this.callNumberData, 'callNumberL1');
    this.resetCallNumberDropdowns();
    if (this.activeFilter && (this.activeFilter.uid > 0 || this.activeFilter.uid == -1)) { // set up from previous selections
      this.working = true;
      if (this.activeFilter.lU_Source) {
        this.luSourceSelection = this.sourceData.filter(x => x.uid == this.activeFilter.lU_Source.uid)[0];
      }
      this.callNumberSourceSelectionId = this.activeFilter.uid;
      this.callNumberL1DisplayData = onlyUniqueByKey(this.callNumberData, 'callNumberL1');
      this.callNumberL1Selection = this.activeFilter.callNumberL1;
      this.callNumberL2Selection = this.activeFilter.callNumberL2;
      this.callNumberL3Selection = this.activeFilter.callNumberL3;
      this.callNumberL4Selection = this.activeFilter.callNumberL4;
      this.chosenSourceCallNumberDescription = this.activeFilter.description;
      this.changeCallNumberSelections();
      this.working = false;
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.focusOnDropdown();
    }, 1000);
  }
  ngOnChanges(s: SimpleChanges) {
    this.callNumberL1DisplayData = onlyUniqueByKey(this.callNumberData, 'callNumberL1');
    // this.callNumberData = this.removeEmpties(this.callNumberData);
    this.removeEmpties();
    // this.chosenSourceCallNumberDescription = '';

    // if (this.callNumberL1DisplayData.length === 1) {
    //   this.callNumberL1Selection = this.callNumberL1DisplayData[0].callNumberL1;
    //   this.changeCallNumberSelections();
    // }

  }
  public focusOnDropdown(): void {
    this.firstControl.nativeElement.focus();
  }
  changeSource(c: LUSource): void {
    this.luSourceSelection = c;
    if (!this.working) {
      this.changeSourceSelection.emit(this.luSourceSelection);
      this.callNumberL1DisplayData = onlyUniqueByKey(this.callNumberData, 'callNumberL1');
      this.callNumberL1Selection = this.activeFilter.callNumberL1;
      this.callNumberL2Selection = this.activeFilter.callNumberL2;
      this.callNumberL3Selection = this.activeFilter.callNumberL3;
      this.callNumberL4Selection = this.activeFilter.callNumberL4;
      this.chosenSourceCallNumberDescription = this.activeFilter.description;
      this.changeCallNumberSelections();
    }
  }
  changeCallNumberSelections(): void {
    // break down next level call number data
    this.callNumberL2Data = this.callNumberData
      .filter(c => c.callNumberL1 === this.callNumberL1Selection)
      .sort((a, b) => a.callNumberL2 > b.callNumberL2 ? 1 : -1);
    if (!this.callNumberL2Data.some(x => x.callNumberL2 === this.callNumberL2Selection)) {
      this.callNumberL2Selection = null;
    }
    this.callNumberL3Data = this.callNumberL2Selection
      ? this.callNumberL2Data.filter(c => c.callNumberL2 === this.callNumberL2Selection)
        .sort((a, b) => a.callNumberL3 > b.callNumberL3 ? 1 : -1)
      : this.callNumberL2Data
        .sort((a, b) => a.callNumberL3 > b.callNumberL3 ? 1 : -1);
    if (!this.callNumberL3Data.some(x => x.callNumberL3 === this.callNumberL3Selection)) {
      this.callNumberL3Selection = null;
    }
    this.callNumberL4Data = this.callNumberL3Selection
      ? this.callNumberL3Data.filter(c => c.callNumberL3 === this.callNumberL3Selection)
        .sort((a, b) => a.callNumberL4 > b.callNumberL4 ? 1 : -1)
      : this.callNumberL3Data
        .sort((a, b) => a.callNumberL4 > b.callNumberL4 ? 1 : -1);
    if (!this.callNumberL4Data.some(x => x.callNumberL4 === this.callNumberL4Selection)) {
      this.callNumberL4Selection = null;
    }

    this.callNumberL2Data = onlyUniqueByKey(this.callNumberL2Data, 'callNumberL2');
    this.callNumberL3Data = onlyUniqueByKey(this.callNumberL3Data, 'callNumberL3');
    this.callNumberL4Data = onlyUniqueByKey(this.callNumberL4Data, 'callNumberL4');
    this.removeEmpties();

    if (this.callNumberL4Selection && this.callNumberL4Selection !== '') {
      const c = this.callNumberData.find(
        a =>
          a.callNumberL4 === this.callNumberL4Selection);
      if (c) {
        this.callNumberL1Selection = c.callNumberL1;
        this.callNumberL2Selection = c.callNumberL2;
        this.callNumberL3Selection = c.callNumberL3;
      }
      this.setCallNumberSelection.emit({ callNumber: this.callNumberL4Selection, level: 4 });
    } else {
      this.setCallNumberSelection.emit({ callNumber: '', level: 4 });
    }
    if (this.callNumberL1Selection && this.callNumberL1Selection !== '') {
      if (!this.callNumberL2Data.length) {
        this.callNumberL2Selection = null;
      }
      this.setCallNumberSelection.emit({ callNumber: this.callNumberL1Selection, level: 1 });
    } else {
      this.setCallNumberSelection.emit({ callNumber: '', level: 1 });
    }
    if (this.callNumberL2Selection && this.callNumberL2Selection !== '') {
      if (!this.callNumberL3Data.length) {
        this.callNumberL3Selection = null;
      }
      this.setCallNumberSelection.emit({ callNumber: this.callNumberL2Selection, level: 2 });
    } else {
      this.setCallNumberSelection.emit({ callNumber: '', level: 2 });
    }
    if (this.callNumberL3Selection && this.callNumberL3Selection !== '') {
      if (!this.callNumberL4Data.length) {
        this.callNumberL4Selection = null;
      }
      this.setCallNumberSelection.emit({ callNumber: this.callNumberL3Selection, level: 3 });
    } else {
      this.setCallNumberSelection.emit({ callNumber: '', level: 3 });
    }
    if ((this.callNumberL1Selection && this.callNumberL1Selection !== '')) {
      const c = this.callNumberData.find(
        a => a.callNumberL1 === this.callNumberL1Selection
          && a.callNumberL2 === this.callNumberL2Selection
          && a.callNumberL3 === this.callNumberL3Selection
          && a.callNumberL4 === this.callNumberL4Selection
      );
      if (!c) {
        this.emitWithWildcardSelectors();
        // this.emitNoSelection();
        return;
      }
      this.callNumberSourceSelectionId = c.uid;
      this.chosenSourceCallNumberDescription = c.description;
      c.lU_Source = this.luSourceSelection;
      // console.debug('source chosen ', this.callNumberSourceSelectionId);
      this.levelOfSpecificity.emit(4);
      this.userSelectionReady.emit([c]); // fulfilled all call # selections.
    } else {
      // this.notiSvc.postNotification(
      //   this.notiSvc.notificationBuilder(
      //     'Invalid Source / Call # Filter',
      //     'Please select at least the first call number level.',
      //     undefined, undefined,
      //     StarbaseNotificationSentiment.Warning));
      this.emitNoSelection();
    }
  }
  /** Triggers emission of an array of CallNumberModels. This signals to the app that we are dealing with wildcard filters. */
  emitWithWildcardSelectors(): void {
    // create new CallNumberModel from chosen-so-far info
    if (this.luSourceSelection && this.luSourceSelection.uid > 0 && this.callNumberL1Selection !== null) { // check validity
      let c: CallNumberModel[] = [];
      if (this.callNumberL2Selection === null) {
        c = this.callNumberData.filter(a =>
          a.lU_SourceUID === this.luSourceSelection.uid
          && a.callNumberL1 === this.callNumberL1Selection);
        this.levelOfSpecificity.emit(1);

      } else if (this.callNumberL3Selection === null) {
        c = this.callNumberData.filter(a =>
          a.lU_SourceUID === this.luSourceSelection.uid
          && a.callNumberL1 === this.callNumberL1Selection
          && a.callNumberL2 === this.callNumberL2Selection);
        this.levelOfSpecificity.emit(2);
      } else if (this.callNumberL4Selection === null) {
        c = this.callNumberData.filter(a =>
          a.lU_SourceUID === this.luSourceSelection.uid
          && a.callNumberL1 === this.callNumberL1Selection
          && a.callNumberL2 === this.callNumberL2Selection
          && a.callNumberL3 === this.callNumberL3Selection);
        this.levelOfSpecificity.emit(3);
      } else {
        c = this.callNumberData.filter(a =>
          a.lU_SourceUID === this.luSourceSelection.uid
          && a.callNumberL1 === this.callNumberL1Selection
          && a.callNumberL2 === this.callNumberL2Selection
          && a.callNumberL3 === this.callNumberL3Selection
          && a.callNumberL4 === this.callNumberL4Selection);
        this.levelOfSpecificity.emit(4);
      }
      c.forEach(cc => cc.lU_Source = this.luSourceSelection);
      try {
        this.chosenSourceCallNumberDescription = c[0].description || '';
      } catch {
        this.chosenSourceCallNumberDescription = '';
      }
      this.userSelectionReady.emit(c);
    } else {
      this.emitNoSelection();
    }
  }
  public resetCallNumberDropdowns(): void {
    // this.luSourceSelection = null;
    this.callNumberSourceSelectionId = undefined;
    this.callNumberL1DisplayData = [];
    this.callNumberL2Data = [];
    this.callNumberL3Data = [];
    this.callNumberL4Data = [];
    this.callNumberL1Selection = null;
    this.callNumberL2Selection = null;
    this.callNumberL3Selection = null;
    this.callNumberL4Selection = null;
    this.chosenSourceCallNumberDescription = '';
  }

  private emitNoSelection(): void {
    this.levelOfSpecificity.emit(0);
    this.userSelectionReady.emit([]);
    this.chosenSourceCallNumberDescription = '';
  }
  private removeEmpties(): void {
    this.callNumberL2Data = this.callNumberL2Data.filter(a =>
      a.callNumberL2 !== ''
    );
    this.callNumberL3Data = this.callNumberL3Data.filter(a =>
      a.callNumberL3 !== ''
    );
    this.callNumberL4Data = this.callNumberL4Data.filter(a =>
      a.callNumberL4 !== ''
    );
  }
  public fillInCallNum(cn: CallNumberModel) {
    this.callNumberL1Selection = this.callNumberL1DisplayData.find(c => c.callNumberL1 == cn.callNumberL1).callNumberL1;
    this.callNumberL2Data = this.callNumberData
      .filter(c => c.callNumberL1 === this.callNumberL1Selection)
      .sort((a, b) => a.callNumberL2 > b.callNumberL2 ? 1 : -1);
    if (cn.callNumberL2) {
      this.callNumberL2Selection = this.callNumberL2Data.find(c => c.callNumberL2 == cn.callNumberL2).callNumberL2;

      this.callNumberL3Data = this.callNumberL2Selection
        ? this.callNumberL2Data.filter(c => c.callNumberL2 === this.callNumberL2Selection)
          .sort((a, b) => a.callNumberL3 > b.callNumberL3 ? 1 : -1)
        : this.callNumberL2Data
          .sort((a, b) => a.callNumberL3 > b.callNumberL3 ? 1 : -1);
      if (!this.callNumberL3Data.some(x => x.callNumberL3 === this.callNumberL3Selection)) {
        this.callNumberL3Selection = null;
      }


      if (cn.callNumberL3) {
        this.callNumberL3Selection = this.callNumberL3Data.find(c => c.callNumberL3 == cn.callNumberL3).callNumberL3;

        this.callNumberL4Data = this.callNumberL3Selection
          ? this.callNumberL3Data.filter(c => c.callNumberL3 === this.callNumberL3Selection)
            .sort((a, b) => a.callNumberL4 > b.callNumberL4 ? 1 : -1)
          : this.callNumberL3Data
            .sort((a, b) => a.callNumberL4 > b.callNumberL4 ? 1 : -1);
        if (!this.callNumberL4Data.some(x => x.callNumberL4 === this.callNumberL4Selection)) {
          this.callNumberL4Selection = null;
        }

        if (cn.callNumberL4) {
          this.callNumberL4Selection = this.callNumberL4Data.find(c => c.callNumberL4 == cn.callNumberL4).callNumberL4;
        }
      }
    }
    this.changeCallNumberSelections()
  }

  elipseDescription(cn: CallNumberModel,level: number){
    var temp = ""
    switch(level){
      case 1:
        temp = cn.description.slice(0,70) + ((cn.description.length) > 70 ? "..." : "");
        break;
      case 2:
        temp = cn.descriptionL2.slice(0,70)+ ((cn.descriptionL2.length) > 70 ? "..." : "");
        break;
      case 3:
        temp = cn.descriptionL3.slice(0,70) + ((cn.descriptionL3.length) > 70 ? "..." : "");
        break;
      case 4:
        temp = cn.descriptionL4.slice(0,70) + ((cn.descriptionL4.length) > 70 ? "..." : "");
        break;
    }
    return temp;
  }
}
